module.exports = __webpack_public_path__ + "static/media/3.1er.349953a7.png";